import axios from "axios";
import config from "../config";
import {
  checkCrediantials,
  getUsernameFromEmail,
  storeUser,
} from "../indexDB/utils/user";
import { handleApiError } from "../components/errorBoundary/errorUtils";

const currentDomain = process.env.REACT_APP_DOMAIN;
const domainConfig = config[currentDomain];
const endpoint = domainConfig.apiEndpoint;

const loginOnline = async (email, password) => {
  try {
    const response = await axios.post(`${endpoint}auth/login`, {
      email: email,
      password: password,
      // once refresh-token implemented accept password or refresh-token
    });
    const { token, username } = response.data;
    // After refresh token implementation use this instead of const { token, username } = response.data;
    // const { token, username, refresh_token } = response.data;
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    await storeUser(email, username, password);
    // After refresh token implementation use this
    // await storeUser(email, username, password, refresh_token);
    return true;
  } catch (error) {
    return handleApiError(error);
  }
};

const getAccessTokenUsingRefreshToken = async (email, password, refreshToken = null) => {
  try {
    // Once Refresh token implemented replace the api and only accept refreshToken in argument and remove email, password from parameter
    const response = await axios.post(`${endpoint}auth/login`, {
      email: email,
      password: password,
    });
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("username", response.data.username)
  } catch (error) {
    return handleApiError(error);
  }

}

const loginOffline = async (email, password) => {
  // remove password from here once refresh token implemented
  try {
    const response = await checkCrediantials(email, password);
    if (response === "User authenticated.") {
      const username = await getUsernameFromEmail(email);
      localStorage.setItem("username", username.username);
      return true;
    }
  } catch (error) {
    console.error(error);
  }
  return false;
};

export { loginOffline, loginOnline, getAccessTokenUsingRefreshToken };
